import { CSSProperties, ReactNode } from "react";
import clsx from "clsx";

/**
 * Cornice condivisa delle mappe: bordo sottile, angoli generosi, e un
 * passe-partout bianco di 6px fra il bordo e la cartografia.
 *
 * Il padding non è decorazione. Senza, le tessere di OpenStreetMap arrivano a
 * filo del bordo e l'angolo arrotondato taglia la mappa: si legge come un
 * difetto di rendering, non come una scelta. Con lo stacco bianco il taglio è
 * dichiarato e la mappa sembra montata dentro una cornice.
 *
 * L'angolo interno vale `map` meno il padding (16 − 6 = 10, il token
 * `map-inner`): due archi concentrici invece di due raggi scelti a occhio, che
 * a ridosso l'uno dell'altro si nota.
 *
 * `sopra` è per i comandi che devono stare SOPRA la mappa ma FUORI dal riquadro
 * che ritaglia — il selettore stradale/satellite, il pulsante schermo intero.
 * Dentro al ritaglio le loro ombre verrebbero tagliate dall'angolo arrotondato.
 */
export function CorniceMappa({
  children,
  sopra,
  className,
  style,
}: {
  children: ReactNode;
  /** Comandi flottanti sopra la mappa (posizionati in assoluto dal chiamante). */
  sopra?: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={clsx("relative rounded-map border border-line bg-white p-1.5 shadow-frame", className)} style={style}>
      {sopra}
      <div className="h-full overflow-hidden rounded-map-inner">{children}</div>
    </div>
  );
}
